import React from 'react'

const NewLoadingUI: React.FC<{bgColor?: string, height?: string, circleDiameter?: string}> = ({bgColor, height, circleDiameter}) => {
    return (
        <div
            role="status"
            className={`grid items-center justify-center ${height ? height : 'h-screen'} md:p-[1%] w-full bg-${bgColor ? bgColor : 'back-400'} pt-16 md:pt-16`}
        >
            <div className={`${(circleDiameter) ? `w-[${circleDiameter}px] h-[${circleDiameter}px]` : 'w-32 h-32'} mr-2 text-gray-200 animate-spin  fill-primaryDark-400`}></div>
        </div>
    );
}

export default NewLoadingUI